import { Controller } from '@hotwired/stimulus';

const SHEET_ID_PATTERN = /[-\w]{25,}/;

export default class extends Controller {
  static targets = [
    'input',
    'gid',
    'result',
    'outputBase',
    'outputAdded',
    'copyButton',
    'gidNote',
    'stepsBody',
    'gidBody',
  ];

  static values = {
    copied: Boolean,
    stepsOpen: Boolean,
    gidOpen: Boolean,
  };

  connect() {
    this.copyLabel = this.copyButtonTarget.textContent;
    this.build();
  }

  build() {
    const match = (this.inputTarget.value || '').match(SHEET_ID_PATTERN);
    const gid = (this.hasGidTarget ? this.gidTarget.value : '').replace(/\D/g, '');
    const gidActive = gid !== '' && gid !== '0';

    if (!match) {
      this.resultTarget.hidden = true;
      if (this.hasGidNoteTarget) this.gidNoteTarget.hidden = true;
      return '';
    }

    const base = `https://docs.google.com/spreadsheets/d/${match[0]}`;
    const added = `/export?format=csv${gidActive ? `&gid=${gid}` : ''}`;

    this.resultTarget.hidden = false;
    this.outputBaseTarget.textContent = base;
    this.outputAddedTarget.textContent = added;

    if (this.hasGidNoteTarget) {
      this.gidNoteTarget.hidden = !gidActive;
      if (gidActive) this.gidNoteTarget.textContent = `Added &gid=${gid} to your link above. ✓`;
    }

    return base + added;
  }

  copy() {
    const output = this.build();
    if (!output) return;

    if (navigator.clipboard) {
      navigator.clipboard.writeText(output);
    }

    this.copyButtonTarget.textContent = 'Copied to your clipboard ✓';
    this.copyButtonTarget.dataset.copied = 'true';
    clearTimeout(this.copyTimer);
    this.copyTimer = setTimeout(() => {
      this.copyButtonTarget.textContent = this.copyLabel;
      this.copyButtonTarget.dataset.copied = 'false';
    }, 1800);
  }

  toggleSteps(event) {
    this.stepsOpenValue = this.stepsBodyTarget.hidden;
    this.stepsBodyTarget.hidden = !this.stepsOpenValue;
    this.toggleDisclosure(event.currentTarget, this.stepsOpenValue);
  }

  toggleGid(event) {
    this.gidOpenValue = this.gidBodyTarget.hidden;
    this.gidBodyTarget.hidden = !this.gidOpenValue;
    this.toggleDisclosure(event.currentTarget, this.gidOpenValue);
  }

  toggleDisclosure(trigger, open) {
    trigger.setAttribute('aria-expanded', String(open));
    const caret = trigger.querySelector('[data-csv-caret]');
    if (caret) caret.textContent = open ? '−' : '+';
  }
}
